class SpektrixAPI {
    constructor() {
        this.apiUrl = window.spektrix_api_url;
    }

    request(resource, verb, data) {
        this.payload = {
            credentials: "include",
            headers: {
                "Content-type": "application/json; charset=UTF-8",
            },
            method: verb,
            body: data ? JSON.stringify(data) : null,
        };

        return fetch(this.apiUrl + resource, this.payload)
            .then(function (response) {
                // console.log(response);

                if (response.status != 204) return response.json();
            })
            .catch((error) => {
                console.log("Error:", error);
            });
    }
}

export default SpektrixAPI;
